import { useState, useEffect } from 'react'
import { useQuery, useLazyQuery } from '@apollo/client/react'
import { useAuthentication } from '@heidelbergmaterials/fcl-authclient'
import Alert from '@mui/material/Alert'
import { graphql } from '../gql'
import { InfoCard } from '../components/ui'

const ME_QUERY = graphql(`
  query Me {
    me {
      name
      claims { type value }
    }
  }
`);

const MY_PROFILE_QUERY = graphql(`
  query MyProfile {
    myProfile {
      displayName
      mail
      jobTitle
      department
      officeLocation
    }
  }
`);

const MY_GROUPS_QUERY = graphql(`
  query MyGroups {
    myGroups {
      id
      displayName
      description
    }
  }
`);

const carouselImages = ['/static/home_carousel1.png', '/static/home_carousel2.png'];

type ActivePanel = 'profile' | 'groups' | 'search' | null;

export function HomePage() {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [activePanel] = useState<ActivePanel>(null);
  const { decodedAccessToken } = useAuthentication();

  const { error: meError } = useQuery(ME_QUERY);
  const [, { data: profileData, error: profileError }] = useLazyQuery(MY_PROFILE_QUERY);
  const [, { data: groupsData, error: groupsError }] = useLazyQuery(MY_GROUPS_QUERY);

  useEffect(() => {
    const timer = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const activeError = meError || profileError || groupsError;

  return (
    <>
    <main className="max-w-[1440px] mx-auto px-6 py-8">
      <div className="flex items-center gap-8 mt-4 mb-8">
        <img src="/static/faim_logo.png" alt="FAIM" className="h-40" />
        <div>
          <h1 className="text-5xl text-hc-text-grey font-light tracking-wide">Welcome{decodedAccessToken?.name ? `, ${decodedAccessToken.name}` : ''}</h1>
          <p className="text-lg text-hc-text-grey tracking-wide mt-2">Fleet Asset Inventory Management</p>
          <p className="text-base text-hc-text-grey/80 italic mt-2">A prompt a day keeps the Blazor away.</p>
        </div>
      </div>

      <div className="relative w-full overflow-hidden shadow-md mb-8">
        {carouselImages.map((src, i) => (
          <img
            key={src}
            src={src}
            alt=""
            className="w-full block transition-opacity duration-700 ease-in-out"
            style={{ opacity: i === carouselIndex ? 1 : 0, position: i === 0 ? 'relative' : 'absolute', top: 0, left: 0 }}
          />
        ))}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {carouselImages.map((_, i) => (
            <button
              key={i}
              onClick={() => setCarouselIndex(i)}
              className={`w-3 h-3 rounded-full transition-colors ${i === carouselIndex ? 'bg-white' : 'bg-white/50'}`}
            />
          ))}
        </div>
      </div>

      {/* <div className="flex gap-4 flex-wrap">
        <Button
          variant="contained"
          color="warning"
          onClick={triggerLoading}
        >
          Test Loading (5s)
        </Button>
        <Button
          variant="contained"
          color="info"
          onClick={() => { setActivePanel('profile'); fetchProfile(); }}
          disabled={activeLoading}
        >
          {profileLoading ? 'Loading...' : 'Get My Profile (Graph)'}
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => { setActivePanel('groups'); fetchGroups(); }}
          disabled={activeLoading}
        >
          {groupsLoading ? 'Loading...' : 'Get My Groups (Graph)'}
        </Button>
      </div> */}

      {activeError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {activeError.message}
        </Alert>
      )}

      {/* {meData && !activePanel && (
        <InfoCard title={`Logged in as: ${meData.me.name}`}>
          <pre className="text-xs font-mono text-hc-text-grey overflow-x-auto">
            {JSON.stringify(meData.me.claims, null, 2)}
          </pre>
        </InfoCard>
      )} */}

      {activePanel === 'profile' && profileData && (
        <InfoCard title="My Profile">
          <pre className="text-xs font-mono text-hc-text-grey overflow-x-auto">
            {JSON.stringify(profileData.myProfile, null, 2)}
          </pre>
        </InfoCard>
      )}

      {activePanel === 'groups' && groupsData && (
        <InfoCard title={`My Groups (${groupsData.myGroups.length})`}>
          <pre className="text-xs font-mono text-hc-text-grey overflow-x-auto max-h-64 overflow-y-auto">
            {JSON.stringify(groupsData.myGroups, null, 2)}
          </pre>
        </InfoCard>
      )}

     
    </main>
    </>
  );
}
